import {
	CalendarDaysIcon,
	CalendarIcon,
	ClockIcon,
	MapPinIcon,
} from '@heroicons/react/24/outline'
import { useTranslation } from 'react-i18next'
import AddToCalendarButton from '@/pages/centrumSzkolen/common/AddToCalendarButton'
import NavigateButton from '@/pages/centrumSzkolen/common/NavigateButton'

const formatDate = value => value ? `${value}`.substring(0, 10) : '—'

const formatLocation = training => {
	if (training?.location) return training.location

	const parts = [
		training?.adres,
		training?.miasto,
		training?.kod_pocztowy,
	].map(value => `${value || ''}`.trim()).filter(Boolean)

	return parts.length ? parts.join(', ') : '—'
}

const secondaryButtonClassName = 'inline-flex items-center justify-center gap-2 rounded-md border border-gray-200 bg-white px-4 py-2 text-sm font-semibold text-gray-700 transition hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-60'

const DetailRow = ({ icon: Icon, label, children }) => (
	<div className="flex items-start gap-3">
		<Icon className="mt-0.5 size-5 shrink-0 text-indigo-500" aria-hidden="true" />
		<div className="min-w-0">
			<dt className="text-xs font-medium uppercase tracking-wide text-gray-500">{label}</dt>
			<dd className="mt-0.5 text-gray-900">{children}</dd>
		</div>
	</div>
)

export default function DateAndLocation({ training }) {
	const { t } = useTranslation()

	return (
		<div className="flex h-full flex-col rounded-md border border-gray-200 bg-white px-5 py-4 shadow-sm">
			<h2 className="text-sm font-semibold text-gray-900">{t('trainings.details.sections.schedule')}</h2>
			<div className="mt-4 flex flex-1 flex-col justify-center">
				<dl className="flex flex-col gap-4">
					<DetailRow icon={MapPinIcon} label={t('trainings.form.fields.location')}>
						{formatLocation(training)}
					</DetailRow>
					<DetailRow icon={CalendarDaysIcon} label={t('trainings.form.fields.trainingDate')}>
						{formatDate(training.data_rozpoczecia)}
					</DetailRow>
					<DetailRow icon={ClockIcon} label={t('trainings.form.fields.startTime')}>
						{training.startTime || training.godzina_rozpoczecia || '—'}
					</DetailRow>
					<DetailRow icon={CalendarIcon} label={t('trainings.form.fields.trainingEndDate')}>
						{formatDate(training.data_zakonczenia || training.data_rozpoczecia)}
					</DetailRow>
					<DetailRow icon={ClockIcon} label={t('trainings.form.fields.endTime')}>
						{training.endTime || training.godzina_zakonczenia || '—'}
					</DetailRow>
				</dl>

				<div className="mt-6 flex flex-wrap justify-center gap-3">
					<NavigateButton training={training} />
					<AddToCalendarButton training={training} className={secondaryButtonClassName} />
				</div>
			</div>
		</div>
	)
}
